<template>
  <div class="projects" id="projects">
    <b-row style="align-items: start">
      <b-col cols="12" md="10" order-md="1" order="2" class="flex-container">
        <b-carousel id="carousel-fade" style="text-shadow: 0px 0px 2px #000" fade indicators img-width="300"
          img-height="100" v-model="currentSlide">
          <div v-for="(project, i) in projects" :key="i">
            <b-carousel-slide :img-src="project.image" @click="showSlide(i)"></b-carousel-slide>
          </div>
        </b-carousel>
        <div class="description">
          <div v-for="(project, i) in projects" :key="i">
            <div v-show="currentSlide === i">
              <h3>{{ project.name }}</h3>
              <p>{{ project.description }}</p>
              <b-button v-if="project.link" :href="project.link" target="_blank" class="view-site"><b-icon
                  icon="box-arrow-in-up-right"></b-icon>View
                Site</b-button>
              <h4>Technologies</h4>
              <p class="tech">
                <b-badge v-for="(tech, i) in project.technology" :key="i">
                  {{ tech }}</b-badge>
              </p>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="2" order-md="2" order="1" class="title">
        <h1>|Projects</h1>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentSlide: 0,
      projects: [
        {
          name: 'fetch English',
          image: require('../assets/projects/fetchenglish.png'),
          // link: 'http://www.fetchenglish.com/',
          description:
            'A website that allows English learners to register for online courses with FetchEnglish. After becoming a member, students and teachers can log in to track completed lessons and read feedback after each class.',
          technology: [
            'Nodejs',
            'Express',
            'MongoDB',
            'HTML5',
            'Bootstrap 4',
            'CSS',
          ],
        },
        {
          name: 'maca van phuc',
          image: require('../assets/projects/macavanphuc.png'),
          link: 'https://macadamia-vanphuc.web.app/',
          description:
            'It’s a one-page website that’s easy to navigate. Users can learn about macadamia nuts and the products offered by Maca Van Phuc Company, then place orders online. I aimed for a modern UI/UX design that’s intuitive for both customers and admins to use and manage.',
          technology: [
            'Nodejs',
            'Reactjs',
            'Redux',
            'Firebase',
            'HTML5',
            'React-Bootstrap',
            'SCSS',
          ],
        },
        {
          name: 'our rainbow',
          image: require('../assets/projects/ourrainbow.png'),
          link: 'https://my-rainbow-f2cdf.web.app/',
          description:
            'Our Rainbow is a website where users can stay up to date with news and articles across different topics. It’s eye-catching, colorful, and easy to navigate. While building this website, I focused on creating a well-designed experience that clearly conveys my client’s message.',
          technology: [
            'Nodejs',
            'Vuejs',
            'Firebase',
            'HTML5',
            'Bootstrap-vue',
            'SCSS',
          ],
        },
      ],
    };
  },
  methods: {
    showSlide(index) {
      this.currentSlide = index;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../styles/views/Projects.scss";
</style>
